import Component from 'flarum/common/Component';
import GroupBadge from 'flarum/common/components/GroupBadge';
import managedGroups from '../utils/managedGroups';
export default class ManagedGroups extends Component {
  view() {
    const groups = managedGroups(this.attrs.criteria);
    const user = this.attrs.user;
    return m("div", {
      className: "ManagedGroups Form-group"
    }, m("hr", null), m("h4", null, app.translator.trans('askvortsov-auto-moderator.lib.managed_groups.header')), m("ul", null, groups.map(group => m("label", {
      className: "checkbox"
    }, user && m("input", {
      type: "checkbox",
      checked: user.groups().includes(group),
      disabled: true
    }), app.translator.trans('askvortsov-auto-moderator.lib.managed_groups.group_item', {
      badge: GroupBadge.component({
        group,
        label: ''
      }),
      groupName: group.nameSingular()
    })))), m("p", null, app.translator.trans('askvortsov-auto-moderator.lib.managed_groups.groups_not_editable')));
  }
}
flarum.reg.add('askvortsov-auto-moderator', 'common/components/ManagedGroups', ManagedGroups);